import axios, { AxiosRequestConfig } from 'axios';

const defaultTimeoutLength = 60000; // 60 seconds

export type FetchConfig = AxiosRequestConfig;

export const axiosInstance = axios.create({
    baseURL: '/api/',
    headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json; charset=utf-8',
    },
});

export function executeGetRequest<ResponseType>(path: string, config?: AxiosRequestConfig) {
    return axiosInstance.get<ResponseType>(path, {
        timeout: defaultTimeoutLength,
        ...config,
    });
}

export function executePostRequest<ResponseType>(path: string, data: object | FormData = {}, config?: AxiosRequestConfig) {
    return axiosInstance.post<ResponseType>(path, data, {
        timeout: defaultTimeoutLength,
        ...config,
    });
}

export function executePutRequest<ResponseType>(path: string, data: object = {}, config?: AxiosRequestConfig) {
    return axiosInstance.put<ResponseType>(path, data, {
        timeout: defaultTimeoutLength,
        ...config,
    });
}

export function executeDeleteRequest<ResponseType>(path: string, data: object = {}, config?: AxiosRequestConfig) {
    return axiosInstance.delete<ResponseType>(path, {
        timeout: defaultTimeoutLength,
        ...config,
        data,
    });
}
